import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-arrow-icon/jb-arrow-icon.scss?inline
var jb_arrow_icon_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

div {
  align-items: center;
  block-size: 32px;
  display: flex;
  transition: transform 0.3s, opacity 0.3s;
}
div:hover:not(.disabled) {
  cursor: pointer;
  transform: translateX(3px);
}

.left {
  transform: scale(-1, 1);
}
.left:hover:not(.disabled) {
  transform: scale(-1, 1) translateX(3px);
}

svg {
  fill: var(--stroke-color, #141e55);
}

.disabled,
.swiper-button-disabled {
  opacity: 0.2;
}`;

// src/components/icons/jb-arrow-icon/jb-arrow-icon.ts
var JbArrowIcon = class extends r2 {
  constructor() {
    super(...arguments);
    this.direction = "right";
    this.disabled = false;
  }
  render() {
    return ke`
      <div class="${this.direction || "right"} ${this.disabled ? "disabled" : ""}">
        <svg
          width="38"
          height="23"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34.1 10L25.5 1.42 26.94 0l10 10H37v.06l1.08 1.08-1.42 1.42-10.24 10.23L25 21.37 34.37 12H0v-2h34.1z"
            fill-rule="evenodd"
          />
        </svg>
      </div>
    `;
  }
};
JbArrowIcon.styles = r(jb_arrow_icon_default);
__decorateClass([
  n()
], JbArrowIcon.prototype, "direction", 2);
__decorateClass([
  n({ type: Boolean })
], JbArrowIcon.prototype, "disabled", 2);
JbArrowIcon = __decorateClass([
  customElement("jb-arrow-icon")
], JbArrowIcon);

export {
  JbArrowIcon
};
